import React from "react";
import styled from "styled-components";
import chevDown from "./assets/chev-down.svg";
import check from "./assets/check.svg";

export default ({
  objectives,
  selected,
  subObjectives,
  onObjectiveChange,
  onSubObjectiveChange
}) => (
  <div>
    <Title>What is your primary objective?</Title>
    <Label>
      <Select
        value={selected.data.id}
        onChange={e => {
          const id = +e.target.value;
          onObjectiveChange(id);
        }}
      >
        {objectives.data.map(({ label, id }, i) => (
          <option key={i} value={id}>
            {label}
          </option>
        ))}
      </Select>
      <Chev src={chevDown} />
    </Label>
    <Wrap>
      <Choices>
        {!selected.data.published_objectives.length
          ? "No objectives"
          : selected.data.published_objectives.map(
              ({ id, label, price }, i) => (
                <Choice
                  value={subObjectives.includes(id)}
                  onChange={checked => onSubObjectiveChange(id, checked)}
                  title={label}
                  price={price}
                  key={i}
                />
              )
            )}
      </Choices>
    </Wrap>
  </div>
);

const Choice = ({ value, title, price, onChange }) => (
  <ChoiceWrap>
    <div className="relative mr2">
      <Check
        type="checkbox"
        checked={value}
        onChange={e => {
          onChange(e.target.checked);
        }}
      />
      <Mark src={check} alt="" />
    </div>
    <ChoiceTitle checked={value}>{title}</ChoiceTitle>
    {price ? <Price className="ml-auto">+${price}</Price> : null}
  </ChoiceWrap>
);

const Price = styled.div`
  font-size: 1.25rem;
  font-family: "CircularStd-Bold", sans-serif;
  color: #bababa;
`;

const Mark = styled.img`
  display: none;
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 1rem;
`;

const Choices = styled.form`
  border-radius: 3px;
  font-family: "CircularStd-Book", sans-serif;
  background-color: #fff;
  padding: 1rem 2.5rem;
  @media (max-width: 680px) {
    padding: 1rem;
  }
`;

const ChoiceWrap = styled.label`
  padding: 1rem 0;
  font-size: 1.35rem;
  display: flex;
  align-items: center;
  outline: 0;
  border-bottom: 1px solid #ebe8e1;
  cursor: pointer;
  &:last-child {
    border-bottom: 0;
  }
  @media (max-width: 680px) {
    font-size: 1rem;
  }
`;

const ChoiceTitle = styled.div`
  color: #5b5f66;
  @media (max-width: 680px) {
    color: #5b5f66;
  }
  ${({ checked }) =>
    checked &&
    `
    color: #000;
  `};
`;

const Wrap = styled.div`
  box-shadow: 15px 15px #ebe8e1;
  @media (max-width: 680px) {
    box-shadow: unset;
  }
`;

const Check = styled.input`
  appearance: none;
  outline: 0;
  height: 2rem;
  width: 2rem;
  border: 3px solid #ebe8e1;
  border-radius: 50%;
  display: flex;
  &:checked {
    border-color: #f76267;
  }
  &:checked + ${Mark} {
    display: block;
  }
  &:checked + ${Mark} + ${ChoiceTitle} {
    color: #000000;
  }
`;

const Select = styled.select`
  appearance: none;
  outline: 0;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  font-family: "CircularStd-Book", sans-serif;
  font-size: 1.6rem;
  padding: 1rem 2.5rem;
  background-color: #fff;
  border-radius: 3px;
  width: 100%;
  @media (max-width: 680px) {
    font-size: 1em;
    padding: 1rem;
  }
`;

const Chev = styled.img`
  margin-left: auto;
  width: 1rem;
  position: absolute;
  right: 2.5rem;
  top: 0;
  bottom: 0;
  margin: auto 0;
`;

const Label = styled.label`
  position: relative;
  display: block;
  margin-bottom: 1rem;
`;

const Title = styled.div`
  color: #a1a19f;
  font-size: 1.75rem;
  font-family: "CircularStd-Book", sans-serif;
  margin-bottom: 0.65rem;
  @media (max-width: 680px) {
    font-size: 1.3rem;
  }
`;



// WEBPACK FOOTER //
// ./src/components/common/candidate/ScheduleCall/components/Objective/View.js